import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Alert } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const peserta = [
  'Agus Santana', 'Akhbar', 'Alfian', 'Alif', 'Alvaro', 'Andri', 'Angga Guntara', 'Arifin', 'Bahar', 'Bayu',
  'Candra', 'Cepi', 'Citra F', 'Dani', 'Darma', 'Dennis', 'Erlangga', 'Eris', 'Evi', 'Evy', 'Eza',
  'Fahri', 'Faisal Agam', 'Faiz', 'Faqih', 'Farhan', 'Fitrah MP', 'Galih', 'Ibda', 'Ibra', 'Inda Maulid',
  'Indra Anggara', 'Iqbal', 'Iqbal SN', 'Ismatul', 'Izzu', 'Juanita', 'Kefin', 'Lukman', 'Lukman Gondrong', 'Mametz',
  'Menia', 'Muhammad Iqbal', 'Muhammad Irfan', 'Nistul', 'Opik', 'Opik Firman', 'Rafi', 'Rahma', 'Rahmat', 'Ratna',
  'Rikha', 'Sasa', 'Samuel', 'Shodiq', 'Tarshulman', 'Windi', 'Yoel', 'Yungki', 'Zia', 'Zulfan', 'Azmi', 'Afri', 'Adhit'
];

const pesertaSorted = [...peserta].sort((a, b) => a.localeCompare(b, 'id'));

const tambahanPeserta = [
  'Aldo', 'Ipung', 'Ambar', 'Andrian', 'Salim', 'Rohmat', 'Ihsan', 'Rendy Zakaria', 'Emir', 'Boby', 'Nida', 'Ira', 'Aziz', 'Fajar', 'Thopan'
];
const tambahanPesertaSorted = [...tambahanPeserta].sort((a, b) => a.localeCompare(b, 'id'));

const TurnamenIntermediate: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', py: { xs: 3, md: 6 }, px: { xs: 2, md: 0 } }}>
      <Helmet>
        <title>Turnamen Intermediate - RaketerS</title>
      </Helmet>
      <Typography variant="h4" component="h1" fontWeight={700} gutterBottom align="center">
        Turnamen Intermediate RaketerS
      </Typography>
      <Alert severity="info" sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}>
        Akan diadakan turnamen pada <b>19 Juli 2025</b> di <b>RaketerS</b>.
      </Alert>
      <Typography paragraph>
        Peserta turnamen telah dipilih dan diundang berdasarkan level yang sesuai, untuk menghindari pemain dengan level yang lebih tinggi atau tidak sesuai ikut serta di dalam turnamen yang dapat menyebabkan pertandingan menjadi tidak seimbang.
      </Typography>
      <Typography paragraph>
        Hanya orang-orang yang pernah bermain di <b>RaketerS</b>, baik itu <b>RaketerS Bandung</b> maupun <b>RaketerS Bandung Selatan</b>, yang berhak mengikuti turnamen ini.
      </Typography>
      <Box sx={{ mb: 2, textAlign: 'center' }}>
        <a
          href="https://docs.google.com/document/d/10ljdyQL2QkzQEH_CU0m8WM2qQoaCUg9u1wzMPcYrkME/edit?tab=t.0"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontWeight: 700, color: '#1976d2', textDecoration: 'underline', fontSize: 18 }}
        >
          📄 Lihat Juknis Turnamen RaketerS Intermediate
        </a>
      </Box>
      <Typography paragraph>
        Berikut adalah daftar nama yang berhak dan diundang untuk mengikuti turnamen:
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 3 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: 700, width: 60 }}>No</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Nama Peserta</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pesertaSorted.map((nama, idx) => (
              <TableRow key={nama}>
                <TableCell align="center">{idx + 1}</TableCell>
                <TableCell>{nama}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Tabel tambahan peserta */}
      <Typography paragraph sx={{ mt: 4, fontWeight: 600 }}>
        Tambahan pemain yang berhak mengikuti turnamen intermediate:
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 3 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: 700, width: 60 }}>No</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Nama Peserta</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tambahanPesertaSorted.map((nama, idx) => (
              <TableRow key={nama}>
                <TableCell align="center">{idx + 1}</TableCell>
                <TableCell>{nama}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <a
          href="https://wa.me/6283890485939?text=Saya%20bersedia%20mengikuti%20Turnamen%20RaketerS%20Level%20Intermediate"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <button
            style={{
              background: '#25D366',
              color: 'white',
              fontWeight: 700,
              fontSize: 18,
              border: 'none',
              borderRadius: 8,
              padding: '12px 32px',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              marginBottom: 8
            }}
          >
            Konfirmasi via WhatsApp
          </button>
        </a>
      </Box>
      <Alert severity="warning" sx={{ fontWeight: 600, mb: 2 }}>
        Untuk nama yang sudah masuk list, silakan konfirmasi ke admin apakah akan ikut atau tidak. Jika tidak ada konfirmasi hingga <b>12 Juli 2025</b>, maka dianggap <b>tidak bersedia mengikuti turnamen</b>.
      </Alert>
      <Alert severity="info" sx={{ fontWeight: 600 }}>
        Hanya akan diambil <b>32 orang pertama</b> yang konfirmasi untuk mengikuti turnamen. Jadi, siapa cepat dia dapat!
      </Alert>
      <Box sx={{ textAlign: 'center', mt: 6, mb: 2 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>Sponsored By:</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap' }}>
          <img src="https://i.imgur.com/qmXOn5z.png" alt="Sponsor 1" style={{ height: 112, margin: 8 }} />
          <img src="https://i.imgur.com/NgQhTZi.png" alt="Sponsor 2" style={{ height: 112, margin: 8 }} />
        </Box>
      </Box>
    </Box>
  );
};

export default TurnamenIntermediate; 